/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Projects_BodyInputs */



/**
* | output |
* | --- |
* | "Group chats, files and instructions around one goal, and share the whole thing with colleagues." |
*
* @param {Onboarding_Tour_Projects_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_projects_body = /** @type {((inputs?: Onboarding_Tour_Projects_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Projects_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bündle Chats, Dateien und Anweisungen um ein Ziel und teile das Ganze mit Kolleginnen und Kollegen.")
	return /** @type {LocalizedString} */ ("Group chats, files and instructions around one goal, and share the whole thing with colleagues.")
});